import type { DocumentCategory } from "@/adapters/api";
import { Badge } from "@/components/ui/badge";
import { documentCategoryLabel } from "../../utils/categories.ts";

export function DocumentCategoryBadge({
	category,
}: {
	category: DocumentCategory;
}) {
	return (
		<Badge
			variant="outline"
			className="document-category-badge"
			data-category={category}
		>
			{documentCategoryLabel(category)}
		</Badge>
	);
}
